import { useWindowWidth } from '@prishapolicy/shared/ui';
import { Dispatch, SetStateAction } from 'react';
import { ReadMore } from '../../../product';

export type GlossaryCardProps = {
  className?: string;
  title: string;
  englishContent: string;
  activeIndex?: number;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  idx: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
};

export const GlossaryCard = ({
  className,
  englishContent,
  title,
  setIsOpen,
  setActiveIndex,
  idx,
}: GlossaryCardProps) => {
  const { isLg } = useWindowWidth();

  return (
    <div
      className={` rounded-large border-grey-200 hover:border-primary flex-1 cursor-pointer border-2 bg-white px-6 pt-6 pb-8 hover:bg-blue-100 ${className}`}
      onClick={() => {
        setIsOpen(true);
        setActiveIndex(idx);
      }}
    >
      <h3 className="text-title-6 mb-2 font-bold" dangerouslySetInnerHTML={{ __html: title }}></h3>
      <ReadMore
        englishContent={englishContent}
        limit={isLg ? 80 : 50}
        onClick={() => {
          setIsOpen(true);
          setActiveIndex(idx);
        }}
      />
    </div>
  );
};
